import React, { Component } from 'react';
import NoticeboardAPICall from 'NOTICEBOARD/NoticeboardAPICall';
import { Base64 } from 'js-base64';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import dummyNoticeImage from 'NOTICEBOARD/Components/NoticeList/Image/dummyNoticeImage.png';
import 'NOTICEBOARD/Components/NoticeDetails/noticedetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import { Link } from 'react-router-dom';
import { saveAs } from "file-saver";
import ReactHtmlParser from 'react-html-parser';

class NoticeDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET INSTITUTE DETAILS
            instituteDetailsFetching: false,
            instituteId: '',
            instituteName: '',
            instituteLogo: '',
            invalidUrl: false,

            // VARIABLES TO GET NOTICE LIST
            noticeId: Base64.decode(this.props.match.params.noticeId),
            noticeDetailsFetching: false,
            noticeDetails: {},

            // VARIABLES TO VIEW ATTACHMENT
            attachmentIndex: 0,

            // VARIABLES FOR SUCCESS MESSAGE
            successModal: false,
            successModalType: '',
            successMessage: ''
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET INSTITUTE DETAILS BY URL
        this.apiCallToGetInstituteDetails();
    }

    // API CALL METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteDetails = async() => {
        this.setState({
            instituteDetailsFetching: true
        });

        let requestData = {
            "url": this.props.match.params.instituteUrl,
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'getInstituteDataByURL',
            requestData,
            '/api/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetNoticeList();
            }, 1000);
        } else {
            if(jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    instituteId: apiResult.InstituteId,
                    instituteName: apiResult.InstituteName,
                    instituteLogo: apiResult.InstituteLogo,
                    instituteDetailsFetching: false
                }, () => {
                    // METHOD CALLED TO GET NOTICE DETAILS
                    this.apiCallToGetNoticeDetails();
                });                
            }else {
                this.setState({
                    invalidUrl: true,
                    instituteDetailsFetching: false
                });
            }
        }
    }

    // API CALL METHOD TO GET NOTICE DETAILS
    apiCallToGetNoticeDetails = async() => {
        this.setState({
            noticeDetailsFetching: true
        });

        let requestData = {
            "notice_id": this.state.noticeId,
        };

        let jsonResponse = await NoticeboardAPICall.makeAPICall(
            'getPublicIndividualNoticeDetails',
            requestData,
            '/api/notice/publicNotice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetNoticeDetails();
            }, 1000);
        } else {
            if(jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    noticeDetails: apiResult[this.state.noticeId],
                    noticeDetailsFetching: false
                });    
            }else {
                this.setState({
                    noticeDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting notice details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        let departments = this.state.noticeDetails.department != undefined ? (this.state.noticeDetails.department == '' ? [] : this.state.noticeDetails.department.split(',')) : [];
        let noticeAttachments = this.state.noticeDetails.attachment != undefined ? (this.state.noticeDetails.attachment == '' ? [] : this.state.noticeDetails.attachment.split(',')) : [];
        return (
            <>
                <div className="noticeDetails-container">
                    {
                        this.state.instituteDetailsFetching ?
                            <Spinner />
                        :
                            this.state.invalidUrl ?
                                <div className="invalid-url-message">
                                    <p className="invalidUrl-message">Invalid URL.</p>
                                </div>
                            :
                                <div className="noticeList-details">
                                    <div className="institute-details">
                                        <img alt="logo" src={this.state.instituteLogo} width={40} height={40} />
                                        <h4 style={{ marginLeft: 10 }}>{this.state.instituteName}</h4>
                                    </div>
                                    <div className="noticeDetails-wrapper col-md-12">
                                        <div className="noticeDetails-header">
                                            <Link to={`/${this.props.match.params.instituteUrl}`}>
                                                <FontAwesomeIcon icon={['fas', 'arrow-circle-left']} color='#0465AC' size="lg" style={{ marginRight: 5 }} />
                                            </Link>
                                            <h5>Notice Details</h5>
                                        </div>
                                        <div className="notice-details-container">
                                            <div className="notice-details">
                                                <div className="notice-basic-details">
                                                    <div className="noticeView-title">
                                                        <h4>{this.state.noticeDetails.title}</h4>
                                                    </div>
                                                    <div className="noticeBy-DateTime-category">
                                                        <div className="noticeView-postedBy-dateTime">
                                                            <div className="noticeView-postedBy">
                                                                By {this.state.noticeDetails.addedBy}
                                                            </div>
                                                            <div className="noticeView-dateTime">
                                                                {this.state.noticeDetails.formattedNoticeDate}
                                                            </div>
                                                        </div>
                                                        <div className="noticeView-category-department">
                                                            <div className="noticeView-category">
                                                                <FontAwesomeIcon icon={['fas', 'layer-group']} style={{ marginRight: 5 }} color="#4A4B57" />
                                                                {this.state.noticeDetails.categoryName}
                                                            </div>
                                                            <div className="noticeView-department-container">
                                                                {
                                                                    departments.length > 0 &&
                                                                        <>
                                                                            {
                                                                                departments.map(department => {
                                                                                    return(
                                                                                        <span className="noticeView-department">
                                                                                            <FontAwesomeIcon icon={['fas', 'circle']} style={{ marginRight: 5, fontSize: 8 }} />
                                                                                            <span>{department}</span>
                                                                                        </span>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="noticeView-description">
                                                        {ReactHtmlParser(this.state.noticeDetails.description)}
                                                    </div>
                                                    {
                                                        noticeAttachments.length > 0 &&
                                                            <div className="noticeView-attachments">
                                                                <p>
                                                                    <FontAwesomeIcon icon={['fas', 'paperclip']} style={{ marginRight: 10 }} />
                                                                    Attachments
                                                                </p>
                                                                <div className="attachment-details">
                                                                    {
                                                                        noticeAttachments.map((attachment, attachmentIndex) => {
                                                                            return(
                                                                                attachment.substring(attachment.lastIndexOf('.') + 1) == 'pdf' ?
                                                                                    <div>
                                                                                        <div className="download-container" title="Click to download file" onClick={() => saveAs(this.state.noticeDetails.attachmentPath + attachment, attachment)}>
                                                                                            <FontAwesomeIcon icon={['fas', 'download']} color="#000" />
                                                                                        </div>
                                                                                        <div className="attachment-container" style={{ border: this.state.attachmentIndex == attachmentIndex ? '2px solid #0465AC' : 'none' }} onClick={() => this.setState({ attachmentIndex: attachmentIndex })}>
                                                                                            <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                                                                                        </div>
                                                                                    </div>
                                                                                :
                                                                                    <div>
                                                                                        <div className="download-container" title="Click to download file" onClick={() => saveAs(this.state.noticeDetails.attachmentPath + attachment, attachment)}>
                                                                                            <FontAwesomeIcon icon={['fas', 'download']} color="#000" />
                                                                                        </div>
                                                                                        <div className='attachment-container' style={{ border: this.state.attachmentIndex == attachmentIndex ? '2px solid #0465AC' : 'none' }} onClick={() => this.setState({ attachmentIndex: attachmentIndex })}>
                                                                                            <img src={this.state.noticeDetails.attachmentPath + attachment} width="100%" height="100%" />
                                                                                        </div>
                                                                                    </div>
                                                                            );
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                noticeAttachments.length > 0 &&
                                                    <div className="attachment-preview">
                                                        <div className="preview-attachment-name">
                                                            <p style={{ fontSize: 14 }}>{noticeAttachments[this.state.attachmentIndex]}</p>
                                                            <p style={{ fontSize: 14, color: '#007bff', cursor: 'pointer' }} title="Click to download file" onClick={() => saveAs(this.state.noticeDetails.attachmentPath + noticeAttachments[this.state.attachmentIndex], noticeAttachments[this.state.attachmentIndex])}>
                                                                <FontAwesomeIcon icon={['fas', 'download']} style={{ marginRight: 5 }} />
                                                                Download
                                                            </p>
                                                        </div>
                                                        <div className="preview-file">
                                                            {
                                                                noticeAttachments[this.state.attachmentIndex] != undefined &&
                                                                    <>
                                                                        {
                                                                            noticeAttachments[this.state.attachmentIndex].substring(noticeAttachments[this.state.attachmentIndex].lastIndexOf('.') + 1) == 'pdf' ?
                                                                                <iframe height="100%" width="100%" src={this.state.noticeDetails.attachmentPath + noticeAttachments[this.state.attachmentIndex]} />
                                                                            :
                                                                                <img src={this.state.noticeDetails.attachmentPath + noticeAttachments[this.state.attachmentIndex]} height="100%" width="100%" />
                                                                        }
                                                                    </>
                                                            }
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                    }
                </div>
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
            </>
        );
    }
}

export default NoticeDetails;